/** Types de notification envoyé par le NotificationService. */
export enum ENotificationEventType {
	/** Événement levé lorsque le service de notification détecte un clique sur une notification push et doit router. */
	OnPushClick,
	/** Événement levé lorsque le service de notifications a été levé. */
	Initialised
}